module.exports = __webpack_public_path__ + "img/lock-in-shield.84758cde.svg";